import React from "react";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";
import { Anchor } from "discover.medical.react-component-library";
import { StyledListItem, StyledList } from "./_.styled";

const TITLE_OFFSET = -80;
const scrollWithOffset = el => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo(0, yCoordinate + TITLE_OFFSET);
};

function TableOfContents({ list }) {
  const { path } = useRouteMatch();

  if (!list.length) {
    return null;
  }

  return (
    <StyledList>
      {list.map(listItem => (
        <StyledListItem key={listItem.id}>
          <Anchor href={`${path}#${listItem.id}`} scroll={scrollWithOffset}>
            {listItem.label}
          </Anchor>
        </StyledListItem>
      ))}
    </StyledList>
  );
}

TableOfContents.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
};

export default TableOfContents;
